import React from 'react'
import PropTypes from 'prop-types'
import ReactPlayer from 'react-player'
import "./Video.scss"

const Video = ({ videoComponent }) => {
  return (
    <div className="my-5 container">
      {videoComponent.title && (
        <h3 className="text-uppercase video-title">
          {videoComponent.title}
        </h3>
      )}
      {videoComponent.description && (
        <p className="video-description">
          {videoComponent.description}
        </p>
      )}
      <div className="ratio ratio-16x9 container">
        {videoComponent.videoId ? (
          <ReactPlayer
            url={`https://www.youtube.com/embed/${videoComponent.videoId}?rel=0`}
            controls={true}
            width="100%"
            height="100%"
          />
        ) : videoComponent.mediaVideo?.url && (
          <ReactPlayer
            url={`${videoComponent.mediaVideo.url}`}  
            controls={true}
            width="100%"
            height="100%"
          />
        )}
      </div>
    </div>
  )
}

export default Video

Video.propTypes = {
  videoComponent: PropTypes.object.isRequired
}
